import React, { Component } from "react";
import classnames from "classnames";
import "react-responsive-modal/styles.css";
import Form from "react-bootstrap/Form";
//import Row from "react-bootstrap/Row";
import { Modal } from "react-responsive-modal";
import {
  PopupActionButton,
  PopupInsideButton,
} from "../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { NewInputText } from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { PopupIconButtonReusable } from "../../../../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
import InputNumberFunc from "../../../../../../function/InputNumberFunc";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../store/actions/errorActions";
import {
  super_admin_diner_status_change,
  get_all_vendor_seating_information,
  get_all_vendor_pending_information,
} from "../../../../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import isEmpty from "../../../../../../store/validation/is-Empty";
import store from "../../../../../../store/store";
import { SET_VENDOR_INFORMATION } from "../../../../../../store/types";

export class SuperAdminEditWaitTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      enter_wait_time: "",
      select_wait_time: "",
      diner_id: "",
      vendor_id: "",
      allData: {},
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.allDataProps) !== nextState.diner_id) {
      return {
        diner_id: nextProps.allDataProps._id,
        vendor_id: nextProps.allDataProps.vendor_id,
        allData: nextProps.allDataProps,
      };
    }
  }

  onOpenModal = (e) => {
    this.setState({ open: true });
  };

  onCloseModal = (e) => {
    this.setState({ open: false });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
    });
    this.props.clear_all_errors();
  };

  /***************************
   * @DESC Big Button Handler
   ***************************/
  bigButtonHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      enter_wait_time: type,
    });
  };

  /******************************
   * @DESC - ON PENDING SUBMIT HANDLER
   *****************************/
  onPendingSubmitHandler = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.diner_id;
    // const vendor_id = this.state.vendor_id;
    const formData = {
      wait_time: parseInt(this.state.enter_wait_time),
      diner_status: "NOTSEATED",
    };
    this.props.super_admin_diner_status_change(
      formData,
      diner_id,
      // vendor_id,
      token,
      this.onPendingAcceptSuccess
    );
  };

  onPendingAcceptSuccess = (e) => {
    const data = { vendor_id: this.state.allData.vendor_id };
    this.props.get_all_vendor_pending_information(data);
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
    this.props.closedMainModal();
  };

  /******************************
   * @DESC - ON SEATING SUBMIT HANDLER
   *****************************/
  onSeatingSubmitHandler = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.diner_id;
    // const vendor_id = this.state.vendor_id;
    const formData = {
      wait_time: parseInt(this.state.enter_wait_time),
    };
    this.props.super_admin_diner_status_change(
      formData,
      diner_id,
      // vendor_id,
      token,
      this.onSeatingAcceptSuccess
    );
  };

  onSeatingAcceptSuccess = (e) => {
    const data = { vendor_id: this.state.allData.vendor_id };
    this.props.get_all_vendor_seating_information(data);
    this.props.get_all_vendor_pending_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
  };

  render() {
    const { open, enter_wait_time } = this.state;
    return (
      <div>
        {this.props.editButtonStatus === "pendingEdit" ? (
          <PopupActionButton
            buttonText={this.props.buttonText}
            buttonType="button"
            buttonClass="yesButton"
            onClick={this.onOpenModal}
          />
        ) : (
          <PopupIconButtonReusable
            buttonClass="editButton"
            buttonType="button"
            titleText="Edit Timer"
            image={require("../../../../../../assets/images/ActionImages/image/edit.svg")}
            onClick={this.onOpenModal}
          />
        )}
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="reusable-popup-header-newstyle">
            <h4>
              {this.props.editButtonStatus === "pendingEdit"
                ? "Enter Wait Time"
                : "Edit Wait Time"}
            </h4>
          </div>
          <div className="reason-for-cancellation p-0">
            <Form
              noValidate
              onSubmit={
                this.props.editButtonStatus === "pendingEdit"
                  ? this.onPendingSubmitHandler
                  : this.onSeatingSubmitHandler
              }
            >
              <div className="mt-2 mb-3">
                <div className="d-flex justify-content-between align-items-baseline mb-4">
                  <div className="w-75">
                    <div className="d-flex align-items-center">
                      <NewInputText
                        extraClass="mt-4 mb-0"
                        name="enter_wait_time"
                        inputType="number"
                        onChange={this.onChange}
                        onKeyDown={InputNumberFunc}
                        maxLength="10"
                        onChange={this.onChange}
                        value={this.state.enter_wait_time}
                        labelText="Enter Wait Time"
                        controlClass={"outlined-helperText "}
                      />
                      <p className="minu-section ml-2 mb-0">Mins</p>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="font_20_m">
                  Select one relevant option from below
                </div>
                <div className="font_16_r mt-2 mb-4">
                  Highest value from below will be sent as wait time
                </div>
                <div className="d-flex flex-wrap justify-content-between">
                  <PopupInsideButton
                    buttonClass={
                      enter_wait_time === "00"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                        : "status-selected-button-box font_20_m mb-4"
                    }
                    buttonText="00 &nbsp; Mins"
                    buttonType="button"
                    onClick={(e) => this.bigButtonHandler(e, "00")}
                  />
                  <PopupInsideButton
                    buttonClass={
                      enter_wait_time === "05"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                        : "status-selected-button-box font_20_m mb-4"
                    }
                    buttonText="05 &nbsp; Mins"
                    buttonType="button"
                    onClick={(e) => this.bigButtonHandler(e, "05")}
                  />
                  <PopupInsideButton
                    buttonClass={
                      enter_wait_time === "10"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                        : "status-selected-button-box font_20_m mb-4"
                    }
                    buttonText="10 &nbsp; Mins"
                    buttonType="button"
                    onClick={(e) => this.bigButtonHandler(e, "10")}
                  />
                  <PopupInsideButton
                    buttonClass={
                      enter_wait_time === "15"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                        : "status-selected-button-box font_20_m mb-4"
                    }
                    buttonText="15 &nbsp; Mins"
                    buttonType="button"
                    onClick={(e) => this.bigButtonHandler(e, "15")}
                  />
                  <PopupInsideButton
                    buttonClass={
                      enter_wait_time === "20"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                        : "status-selected-button-box font_20_m mb-4"
                    }
                    buttonText="20 &nbsp; Mins"
                    buttonType="button"
                    onClick={(e) => this.bigButtonHandler(e, "20")}
                  />
                  <PopupInsideButton
                    buttonClass={
                      enter_wait_time === "25"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                        : "status-selected-button-box font_20_m mb-4"
                    }
                    buttonText="25 &nbsp; Mins"
                    buttonType="button"
                    onClick={(e) => this.bigButtonHandler(e, "25")}
                  />
                  <PopupInsideButton
                    buttonClass={
                      enter_wait_time === "30"
                        ? "status-selected-button-box font_20_m sts_sld_btn_box_a mb-4"
                        : "status-selected-button-box font_20_m mb-4"
                    }
                    buttonText="30 &nbsp; Mins"
                    buttonType="button"
                    onClick={(e) => this.bigButtonHandler(e, "30")}
                  />
                </div>
              </div>
              <div className="mt-3 d-flex">
                <ReusableOnboardingButton
                  buttonTitle="Cancel Button"
                  buttonClass={
                    "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                  }
                  buttonText="Cancel"
                  onClick={this.onCloseModal}
                  buttonType="button"
                />
                <ReusableOnboardingButton
                  buttonTitle="Save Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  buttonText="Save"
                  onClick={
                    this.props.editButtonStatus === "pendingEdit"
                      ? this.onPendingSubmitHandler
                      : this.onSeatingSubmitHandler
                  }
                  buttonType="button"
                />
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

SuperAdminEditWaitTime.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  super_admin_diner_status_change,
  get_all_vendor_seating_information,
  get_all_vendor_pending_information,
})(withRouter(SuperAdminEditWaitTime));
